/* eslint @typescript-eslint/no-explicit-any: 0 */
/* eslint @typescript-eslint/no-unused-vars: 0 */

if (!($.validator && $.validator.unobtrusive)) {
	throw new Error('$.validator is not defined. Please load this script **after** loading jquery.validate.js ' +
		'and jquery.validate.unobtrusive.js');
}

// this setup is based on classes used in bootstrap 4
const fieldClasses = [
	'.form-control', '.custom-control-input',
	'.custom-select', '.custom-range', '.custom-file-input'
];
const fieldSelector = fieldClasses.join(',');

const toggleFieldsCss = (element: any, cssToRemove: string, cssToApply: string) => {
	const ignored = $.validator.defaults.ignore;
	$(element).closest('.form-group').find(fieldSelector).not(ignored)
		.removeClass(cssToRemove)
		.addClass(cssToApply);
};

const defaultOptions = {
	validClass: 'is-valid',
	errorClass: 'is-invalid',
	highlight: (element: any, errorClass: string, validClass: string) => {
		toggleFieldsCss(element, validClass, errorClass);
	},
	unhighlight: (element: HTMLElement, errorClass: string, validClass: string) => {
		const validToApply = Array.from(element.classList).some((cls) => cls === 'custom-control-input') ? '' : validClass;

		toggleFieldsCss(element, errorClass, validToApply);
	}
};

$.validator.setDefaults(defaultOptions);

$.validator.unobtrusive.options = {
	errorClass: defaultOptions.errorClass,
	validClass: defaultOptions.validClass,
	errorElement: 'span',
	errorPlacement: (error: any, element: any) => {
		error.addClass('invalid-feedback');
	}
};
